import { Language } from '../../lang/Language'

export class BetUndefinedForPlayer extends Error {
  constructor() {
    super(Language.strings.error.table.betUndefinedForPlayer)
  }
}
